import { ref, computed, onMounted } from 'vue'
import { loadSupportSystemMode } from '../utils/supportTicketsCollection'

export type SystemMode = 'dev' | 'qa' | string

const mode = ref<SystemMode | null>(null)
const display = ref('')
let loadPromise: Promise<void> | null = null

async function loadSystemMode() {
  if (loadPromise) return loadPromise

  loadPromise = loadSupportSystemMode()
    .then((data) => {
      const nextMode = data?.SYSTEM_MODE?.trim() || ''
      const nextDisplay = data?.SYSTEM_MODE_DISPLAY?.trim() || ''
      if (nextMode && nextDisplay) {
        mode.value = nextMode
        display.value = nextDisplay
        document.body.classList.add('has-system-mode-banner')
      }
    })
    .catch(() => {
      /* no banner when config unavailable */
    })

  return loadPromise
}

export function useSystemMode() {
  onMounted(() => {
    void loadSystemMode()
  })

  const visible = computed(() => Boolean(mode.value && display.value))
  const bannerClass = computed(() => {
    if (mode.value === 'dev') return 'system-mode-banner--dev'
    if (mode.value === 'qa') return 'system-mode-banner--qa'
    return 'system-mode-banner--default'
  })

  return { mode, display, visible, bannerClass }
}
